import React from 'react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';

import TreeView from '@zippytech/react-toolkit/TreeView';
import '@zippytech/react-toolkit/TreeView/index.css';

import { Grid } from 'semantic-ui-react';
import ContentTreeMenu from '../../Initiatives/BrowserPane/contentTree'
import LabelWithCount from '../../../common/LabelWithCount';

class LibraryTreeView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentStatus: this.props.activeStatus ? this.props.activeStatus : null,
            customRenderNode: true
        }
    }

    componentWillMount() {
        dispatch.initiatives.setTabName("myactivities")
        let pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_at/myactivities/`;
        if(pathName+"activeInitiatives"== this.props.location.pathname){
            dispatch.initiatives.setPageStatus("activeInitiatives");    
        // this.setState({ currentStatus: "activeInitiatives" }) 
        }else if(pathName+"completedInitiatives"==this.props.location.pathname){
            dispatch.initiatives.setPageStatus("completedInitiatives");
        // this.setState({ currentStatus: "completedInitiatives" })
        }
    }
    nodeStyle = (nodeProps) => {
        if (nodeProps.node.initiativeId === this.props.initiativeId) {
            return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
        } else if (nodeProps.node.value === this.state.currentStatus) {
            return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
        } else {
            return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }
        }
    }

    async onSelectionChange(data) {
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        await dispatch.initiatives.showResourecePane(null);
        await dispatch.initiatives.setInitiativeId(null);
        await dispatch.initiatives.setPageStatus(null);
        const history = this.props.history;
        if (data.depth === 0) {
            this.setState({ currentStatus: null })
            history.push({
                pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_at/myactivities'
            });
        } else if (data.depth === 1) {
            this.setState({ currentStatus: data.node.value })
            await dispatch.initiatives.setPageStatus(data.node.value);
            await dispatch.initiatives.setInitiativeId(null);
            history.push({
                pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_at/myactivities/' + data.node.value
            });
        } else if (data.depth === 2) {
            this.setState({ currentStatus: null })
            await dispatch.initiatives.setInitiativeId(data.node.initiativeId);
            await dispatch.initiatives.getActiveInitiativeDetailsById({ initiativeId: data.node.initiativeId, isMemberView: true });
            await dispatch.initiatives.setPageStatus(null);
            await dispatch.initiatives.showResourecePane(null);
            await dispatch.initiatives.setIdToCenterPosition(null);
            await dispatch.initiatives.setSelectedActivityData({});
            history.push({
                pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_at/myactivities/' + data.parent.node.value + '/' + data.node.initiativeId
            });
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({currentStatus : newProps.activeStatus});
      }

    renderNode = (domProps, nodeProps) => {

        if (nodeProps.node.status === 4) {
            domProps.style.opacity = '.7'
        }
    }

    render() {
        let checkSelectedActivity = Object.entries(this.props.selectedActivityData).length !== 0 && this.props.selectedActivityData.constructor === Object
        let ActiveLabelWithCount = <LabelWithCount label="Active" count={this.props.initiativeCountDataForMember ? this.props.initiativeCountDataForMember.activeInitiatives.length : 0} />;
        let CompleteLabelWithCount = <LabelWithCount label="Completed" count={this.props.initiativeCountDataForMember ? this.props.initiativeCountDataForMember.completedInitiatives.length : 0} />;

        let totalI = this.props.initiativeCountDataForMember ?
            this.props.initiativeCountDataForMember.activeInitiatives.length + this.props.initiativeCountDataForMember.completedInitiatives.length : 0
        let activeInitiativeNode = [];

        this.props.initiativeCountDataForMember &&
            this.props.initiativeCountDataForMember.activeInitiatives.forEach(activeInitiative => {
                activeInitiativeNode.push({
                    label: activeInitiative.name,
                    initiativeId: activeInitiative.id,
                    status: activeInitiative.status
                })
            });

        let completedInitiativeNode = [];
        this.props.initiativeCountDataForMember &&
            this.props.initiativeCountDataForMember.completedInitiatives.forEach(completedInitiative => {
                completedInitiativeNode.push({
                    label: completedInitiative.name,
                    initiativeId: completedInitiative.id,
                    status: completedInitiative.status
                })
            });

        const treeList = [
            {
                label: <strong> <LabelWithCount labelClass="bg-blue" label="My Progress" count={totalI} /> </strong>,
                nodes: [
                    {
                        label: ActiveLabelWithCount,
                        value: 'activeInitiatives',
                        nodes: activeInitiativeNode
                    },
                    {
                        label: CompleteLabelWithCount,
                        value: 'completedInitiatives',
                        nodes: completedInitiativeNode
                    }
                ]
            }
        ];


        return (

            < Grid divided className="practiceTree" columns='equal' >
                <Grid.Row stretched className="pad_0" style={{
                    height: "100%",
                    overflow: "auto"
                }}>
                    <Grid.Column
                        style={{ height: "100%", overflow: "auto", padding: "0" }}  >
                        <TreeView
                            className="browserPane"
                            enableSelection={true}
                            onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
                            dataSource={treeList}
                            singleSelect={true}
                            defaultCollapsedDepth={1}
                            enableHoverStyle={false}
                            enableKeyboardNavigation={false}
                            nodeStyle={this.nodeStyle}
                            renderNode={this.state.customRenderNode ? this.renderNode : undefined}
                        />

                    </Grid.Column>
                    {this.props.activeTab && this.props.activeTab === 'myactivities' && checkSelectedActivity ?
                        <Grid.Column className="pad_0">
                            <ContentTreeMenu  {...this.props} selectedDataById={this.props.selectedActivityData.initiativeId} />
                        </Grid.Column> : ''}
                </Grid.Row>
            </Grid >
        );
    }
}

function mapStateToProps(state) {
    return {
        initiativeCountDataForMember: state.initiatives.initiativeCountDataForMember,
        selectedOrganisation: state.app.selectedOrganisation,
        initiativeId: state.initiatives.initiativeId,
        initiativeMemberActivities: state.initiatives.initiativeMemberActivities,
        publishedContent: state.createPack.publishedContent,
        selectedActivityData: state.initiatives.selectedActivityData,
        activeTab: state.initiatives.activeTab,
    };
}

const connectedLibraryTreeView = connect(mapStateToProps)(LibraryTreeView);

export default connectedLibraryTreeView;